<router-outlet></router-outlet>

<app-loader></app-loader>

<app-toaster-container></app-toaster-container>

<app-export-progress-bar></app-export-progress-bar>